// Categories
export const FILM = 'film';
export const PRINT = 'print';
export const WEB = 'web';
export const PHOTO = 'photo';
export const THREE_D = '3d';
export const OTHER = 'other';
export const EVENT = 'event';
export const MOBILE = 'mobile';
export const EVERYTHING = 'everything';

export default [EVERYTHING, THREE_D, EVENT, FILM, MOBILE, PHOTO, PRINT, WEB, OTHER ];